document.addEventListener('DOMContentLoaded', function() {
    const audio = document.getElementById('welcomeSound');
    // Target the parent link that contains the logo(s) instead of the img directly
    const logoLink = document.querySelector('.header__heading-link');
    
    if (audio && logoLink) {
        // Check if mobile/touch device
        const isMobile = 'ontouchstart' in window || window.innerWidth < 990;
        
        // Desktop hover functionality
        logoLink.addEventListener('mouseenter', function() {
            audio.play().catch(function(error) {
                console.error('Audio playback failed:', error);
            });
        });
        
        // Mobile tap functionality
        if (isMobile) {
            logoLink.addEventListener('click', function(e) {
                // Get the href before preventing default
                const href = logoLink.getAttribute('href');
                
                // Prevent immediate navigation
                e.preventDefault();
                
                // Reset audio to beginning
                audio.currentTime = 0;
                
                // Set up navigation after audio ends
                let hasNavigated = false;
                
                const navigate = function() {
                    if (!hasNavigated) {
                        hasNavigated = true;
                        window.location.href = href;
                    }
                };
                
                // Navigate when audio finishes
                audio.addEventListener('ended', navigate, { once: true });
                
                // Fallback: navigate after 3 seconds max
                const fallbackTimeout = setTimeout(navigate, 3000);
                
                // Play audio
                audio.play().then(function() {
                    // Audio started successfully
                }).catch(function(error) {
                    console.error('Audio playback failed:', error);
                    // If audio fails, clear timeout and navigate immediately
                    clearTimeout(fallbackTimeout);
                    navigate();
                });
            });
        }
    }
});